export const EXPORT_STATUS = {
  QUEUED: 'queued',
  RUNNING: 'running',
  COMPLETED: 'completed',
  FAILED: 'failed'
};

// Lifecycle rank — keeps status moving forward only. `completed` and `failed`
// share the top rank (both terminal). Unknown status → -1 (treated as malformed).
export const STATUS_RANK = {
  [EXPORT_STATUS.QUEUED]: 0,
  [EXPORT_STATUS.RUNNING]: 1,
  [EXPORT_STATUS.COMPLETED]: 2,
  [EXPORT_STATUS.FAILED]: 2
};

export const EXPORT_POLL_INTERVAL_MS = 3000;

// Ceiling for the inline invoice-preview poll: a job that never reports terminal
// (dead worker, blocked request) must surface an error instead of spinning forever.
export const EXPORT_POLL_TIMEOUT_MS = 120000;

// list_jobs hard-rejects more than this many ids (backend MAX_LIMIT).
export const EXPORT_IDS_LIMIT = 25;

// Clock-skew and transfer margin applied before treating a signed link as expired.
export const EXPIRY_SKEW_MS = 30000;

// How long a job flagged stale keeps being polled for a late recovery before the dock
// accepts the failure and stops.
export const STALE_RECOVERY_WINDOW_MS = 600000;

export const EXPORT_JOBS_QUERY_KEY = 'export-jobs';

export const exportJobsKey = (limit, ids) => [EXPORT_JOBS_QUERY_KEY, limit, ids];
